import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { PreenchimentoListComp } from 'pages/financeiro/dre/preenchimento/components';
import { PreenchimentoProvider } from 'pages/financeiro/dre/preenchimento/contexts';

export function PreenchimentoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['FINANCEIRO_DRE_PREENCHIMENTO_GERENCIAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <PreenchimentoProvider>
                <PreenchimentoListComp />
            </PreenchimentoProvider>
        </ListagemProvider>
    );
}
